import { render } from "./ProblemDrawer.vue?vue&type=template&id=50daee6b&scoped=true&ts=true"
import script from "./ProblemDrawer.vue?vue&type=script&lang=ts"
export * from "./ProblemDrawer.vue?vue&type=script&lang=ts"

import "./ProblemDrawer.vue?vue&type=style&index=0&id=50daee6b&lang=scss&scoped=true"
import "./ProblemDrawer.vue?vue&type=style&index=1&id=50daee6b&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50daee6b"]])

export default __exports__